import { useState, useMemo, useCallback, MouseEventHandler } from 'react';
import { Helmet } from 'react-helmet-async';
import { Box } from '@mui/material';
import { getTableConfigs } from './components/tableConfigs';
import SandboxesTable from './components/SandboxesTable';
import RealmsSearchFilters from './components/RealmsSearchFilters';
import { useRealmTableBulkActionMenu } from './hooks/useRealmTableBulkActionMenu';
import { RealmTypes, DEFAULT_REALM_TABLE_VIEW } from 'RealmModule/constants/realm';
import StandardPageHeader from 'components/StandardPageHeader';

const SandboxesPageContainer = () => {
  const [sandboxTableView, setSandboxTableView] = useState(DEFAULT_REALM_TABLE_VIEW);
  const [submittedSearch, setSubmittedSearch] = useState({
    searchText: '',
    submitCount: 0,
  });

  const tableConfig = useMemo(
    () => getTableConfigs({ variant: sandboxTableView }),
    [sandboxTableView],
  );

  const { openRealmTableBulkSelectMenu, checkedSandboxes, setCheckedSandboxesSet } =
    useRealmTableBulkActionMenu({
      realmType: RealmTypes.sandbox,
      tableView: sandboxTableView,
    });

  const onFiltersSubmit = useCallback(
    ({ searchText }: { searchText: string }) => {
      setSubmittedSearch((prev) => ({
        searchText,
        submitCount: prev.submitCount + 1,
      }));
      setCheckedSandboxesSet(new Set());
    },
    [setCheckedSandboxesSet],
  );

  const onModifyClick: MouseEventHandler<HTMLElement> = (e) => {
    openRealmTableBulkSelectMenu({ target: e.currentTarget });
  };

  return (
    <Box>
      <Helmet title="Sandboxes" />

      <StandardPageHeader
        title="Sandboxes"
        subtitle="Manage sandbox environments and configurations"
        icon="Sandbox"
        sx={{ mb: 6 }}
      />

      <RealmsSearchFilters realmType={RealmTypes.sandbox} onSubmit={onFiltersSubmit} />

      <SandboxesTable
        tableConfig={tableConfig}
        sandboxTableView={sandboxTableView}
        setSandboxTableView={setSandboxTableView}
        onModifyButtonClick={onModifyClick}
        checkedSandboxes={checkedSandboxes}
        setCheckedSandboxesSet={setCheckedSandboxesSet}
        realmType={RealmTypes.sandbox}
        showFilter={false}
        searchText={submittedSearch.searchText}
        filtersSubmitCount={submittedSearch.submitCount}
      />
    </Box>
  );
};

export default SandboxesPageContainer;
